import React from "react";
import { Box, Skeleton, Container } from "@mui/material";

interface CommonInterlinkingSkeletonProps {
  itemCount?: number;
}

const CommonInterlinkingSkeleton = ({ itemCount = 5 }: CommonInterlinkingSkeletonProps) => (
  <Box
    component="section"
    aria-labelledby="interlinking-heading-skeleton"
    className="destination-page-container"
    sx={{ p: { xs: "4rem 2.4rem", sm: "4rem 2.4rem", lg: "4rem 10rem 6rem" } }}
  >
    {/* Heading Skeleton */}
    <Skeleton
      id="interlinking-heading-skeleton"
      variant="text"
      width="200px"
      height="48px"
      sx={{ mb: "2.4rem" }}
    />

    <Container maxWidth={false} disableGutters>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            sm: "1fr 1fr",
            lg: "repeat(5, 1fr)"
          },
          gap: "2rem"
        }}
      >
        {Array.from({ length: itemCount }, (_, index) => (
          <Skeleton
            key={index}
            variant="rounded"
            width="100%"
            height="80px"
            sx={{ borderRadius: "2rem" }}
          />
        ))}
      </Box>
    </Container>
  </Box>
);

export default CommonInterlinkingSkeleton;
